<ul>
  <li><a class="{{current == 1 ? 'disabled': ''}}" href="javascript:void(0);" data-index="{{current - 1}}" data-tabid="{{tabId}}" sk-event.click="{{current == 1 ? 'nothing()': 'tipsShow()'}}"
    {{if style.model == 'custom'}}
      style="color: {{style.color}}"
    {{/if}}
  >‹</a></li>
   {{if current > 3 && pageNum > 5}}
      <li><a
        {{if style.model == 'custom'}}
          {{if $value == current}}
            style="background-color:{{style.color4}}; color: {{style.color2}}"
            {{else}}
            style="background-color:{{style.color3}}; color: {{style.color}}"
          {{/if}}
        {{/if}}
      >···</a></li>
   {{/if}}
  {{each pageIndexListCurrent}}
    <li>
     <a href="javascript:void(0);" data-index="{{$value}}" data-tabid="{{tabId}}" sk-event.click="tipsShow()" class="{{$value == current? 'active':''}}"
      {{if style.model == 'custom'}}
        {{if $value == current}}
          style="background-color:{{style.color4}}; color: {{style.color2}}"
          {{else}}
          style="background-color:{{style.color3}}; color: {{style.color}}"
        {{/if}}
      {{/if}}
     >{{$value}}</a>
    </li>
  {{/each}}
  {{if (current < pageNum-2) && pageNum > 5}}
    <li><a
      {{if style.model == 'custom'}}
        {{if $value == current}}
          style="background-color:{{style.color4}}; color: {{style.color2}}"
          {{else}}
          style="background-color:{{style.color3}}; color: {{style.color}}"
        {{/if}}
      {{/if}}
    >···</a></li>
  {{/if}}
  <li><a class="{{current == pageNum ? 'disabled': ''}}" href="javascript:void(0);" data-index="{{current + 1}}" data-tabid="{{tabId}}" sk-event.click="{{current == pageNum ? 'nothing()': 'tipsShow()'}}"
    {{if style.model == 'custom'}}
      style="color: {{style.color}}"
    {{/if}}
  >›</a></li>
</ul>